/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { AdmTransferDocument } from "../models/adm-transfer-document";
import { AdmTransferExportOptions } from "../models/adm-transfer-export-options";
import { AdmTransferPlan } from "../models/adm-transfer-plan";
import { AdmTransferImportRequest } from "../models/adm-transfer-import-request";
import { AdmTransferApplyResult } from "../models/adm-transfer-apply-result";
import { AdmTransferApplyRequest } from "../models/adm-transfer-apply-request";
import { AdmFlattenCopyAnalysis } from "../models/adm-flatten-copy-analysis";
import { AdmFlattenCopyAnalyzeRequest } from "../models/adm-flatten-copy-analyze-request";
import { AdmFlattenCopyResult } from "../models/adm-flatten-copy-result";
import { AdmFlattenCopyRequest } from "../models/adm-flatten-copy-request";
@Injectable({
  providedIn: "root",
})
class AdminAdmTransferService extends __BaseService {
  static readonly adminAdmTransferExportPath = "/api/AdminAdmTransfer/Export";
  static readonly adminAdmTransferImportPreviewPath =
    "/api/AdminAdmTransfer/ImportPreview";
  static readonly adminAdmTransferImportApplyPath =
    "/api/AdminAdmTransfer/ImportApply";
  static readonly adminAdmTransferAnalyzeFlattenCopyPath =
    "/api/AdminAdmTransfer/AnalyzeFlattenCopy";
  static readonly adminAdmTransferBuildFlattenCopyPath =
    "/api/AdminAdmTransfer/BuildFlattenCopy";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * @param options undefined
   */
  adminAdmTransferExportResponse(
    options: AdmTransferExportOptions
  ): __Observable<__StrictHttpResponse<AdmTransferDocument>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = options;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminAdmTransfer/Export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmTransferDocument>;
      })
    );
  }
  /**
   * @param options undefined
   */
  adminAdmTransferExport(
    options: AdmTransferExportOptions
  ): __Observable<AdmTransferDocument> {
    return this.adminAdmTransferExportResponse(options).pipe(
      __map((_r) => _r.body as AdmTransferDocument)
    );
  }

  /**
   * @param request undefined
   */
  adminAdmTransferImportPreviewResponse(
    request: AdmTransferImportRequest
  ): __Observable<__StrictHttpResponse<AdmTransferPlan>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminAdmTransfer/ImportPreview`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmTransferPlan>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminAdmTransferImportPreview(
    request: AdmTransferImportRequest
  ): __Observable<AdmTransferPlan> {
    return this.adminAdmTransferImportPreviewResponse(request).pipe(
      __map((_r) => _r.body as AdmTransferPlan)
    );
  }

  /**
   * @param request undefined
   */
  adminAdmTransferImportApplyResponse(
    request: AdmTransferApplyRequest
  ): __Observable<__StrictHttpResponse<AdmTransferApplyResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminAdmTransfer/ImportApply`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmTransferApplyResult>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminAdmTransferImportApply(
    request: AdmTransferApplyRequest
  ): __Observable<AdmTransferApplyResult> {
    return this.adminAdmTransferImportApplyResponse(request).pipe(
      __map((_r) => _r.body as AdmTransferApplyResult)
    );
  }

  /**
   * @param request undefined
   */
  adminAdmTransferAnalyzeFlattenCopyResponse(
    request: AdmFlattenCopyAnalyzeRequest
  ): __Observable<__StrictHttpResponse<AdmFlattenCopyAnalysis>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminAdmTransfer/AnalyzeFlattenCopy`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmFlattenCopyAnalysis>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminAdmTransferAnalyzeFlattenCopy(
    request: AdmFlattenCopyAnalyzeRequest
  ): __Observable<AdmFlattenCopyAnalysis> {
    return this.adminAdmTransferAnalyzeFlattenCopyResponse(request).pipe(
      __map((_r) => _r.body as AdmFlattenCopyAnalysis)
    );
  }

  /**
   * @param request undefined
   */
  adminAdmTransferBuildFlattenCopyResponse(
    request: AdmFlattenCopyRequest
  ): __Observable<__StrictHttpResponse<AdmFlattenCopyResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminAdmTransfer/BuildFlattenCopy`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmFlattenCopyResult>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminAdmTransferBuildFlattenCopy(
    request: AdmFlattenCopyRequest
  ): __Observable<AdmFlattenCopyResult> {
    return this.adminAdmTransferBuildFlattenCopyResponse(request).pipe(
      __map((_r) => _r.body as AdmFlattenCopyResult)
    );
  }
}

module AdminAdmTransferService {}

export { AdminAdmTransferService };
